import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(username, password);
      if (user.role === "Admin") navigate("/admin/dashboard");
      else if (user.role === "Manager") navigate("/manager/dashboard");
      else navigate("/staff/dashboard");
    } catch (err) {
      setError(
        err.response?.data?.message || "Login failed. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source src="/fog.mp4" type="video/mp4" />
      </video>

      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(135deg, rgba(26,60,94,0.75) 0%, rgba(45,106,79,0.75) 100%)",
          zIndex: 1,
        }}
      />

      {/* Login Card */}
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-8 col-md-6 col-lg-4">
            {/* Logo */}
            <div className="text-center mb-4">
              <div
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                style={{
                  width: 75,
                  height: 75,
                  background: "rgba(255,255,255,0.15)",
                  backdropFilter: "blur(10px)",
                  border: "2px solid rgba(255,255,255,0.3)",
                }}
              >
                <i className="bi bi-building text-white fs-2"></i>
              </div>
              <h3 className="text-white fw-bold mb-1">Nammakshetra</h3>
              <p className="text-white-50 small">MLA Constituency Management</p>
            </div>

            {/* Card */}
            <div
              className="card border-0 rounded-4"
              style={{
                background: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(20px)",
                border: "1px solid rgba(255,255,255,0.2) !important",
                boxShadow: "0 25px 50px rgba(0,0,0,0.3)",
              }}
            >
              <div className="card-body p-4">
                <h5 className="fw-semibold text-center mb-4 text-white">
                  Sign in to your account
                </h5>

                {error && (
                  <div
                    className="alert alert-danger py-2 small border-0"
                    role="alert"
                    style={{
                      background: "rgba(220,53,69,0.2)",
                      color: "#ff8080",
                    }}
                  >
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {error}
                  </div>
                )}

                <form onSubmit={handleLogin}>
                  {/* Username */}
                  <div className="mb-3">
                    <label className="form-label small fw-medium text-white-50">
                      Username
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text border-0"
                        style={{ background: "rgba(255,255,255,0.15)" }}
                      >
                        <i className="bi bi-person text-white"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 text-white"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{
                          background: "rgba(255,255,255,0.15)",
                          color: "white",
                        }}
                        required
                      />
                    </div>
                  </div>

                  {/* Password */}
                  <div className="mb-4">
                    <label className="form-label small fw-medium text-white-50">
                      Password
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text border-0"
                        style={{ background: "rgba(255,255,255,0.15)" }}
                      >
                        <i className="bi bi-lock text-white"></i>
                      </span>
                      <input
                        type="password"
                        className="form-control border-0 text-white"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                          background: "rgba(255,255,255,0.15)",
                          color: "white",
                        }}
                        required
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    className="btn w-100 fw-semibold py-2 text-white"
                    style={{
                      background: "linear-gradient(135deg, #1a3c5e, #2d6a4f)",
                      border: "none",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Signing in...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-box-arrow-in-right me-2"></i>Sign In
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>

            <p className="text-center text-white-50 small mt-3">
              © 2026 Nammakshetra. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
